import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M22 6H12l-2-2H2v16h20V6zm-2 12H4V8h16v10z"
}), 'FolderOpenSharp');